import { useEffect } from 'react';

/**
 * React hook for listening to a mutation observer on an HTML node
 * @param options UseMutationObserverOptions
 * @return void
 */ const useMutationObserver = (options)=>{
    const { callback, mutationObserverOptions = {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    }, node, ref } = options;
    useEffect(()=>{
        if (node) {
            const observer = new MutationObserver(callback);
            observer.observe(node, mutationObserverOptions);
            return ()=>{
                observer.disconnect();
            };
        }
        return;
    }, [
        node
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(()=>{
        if (ref?.current) {
            const observer = new MutationObserver(callback);
            observer.observe(ref.current, mutationObserverOptions);
            return ()=>{
                observer.disconnect();
            };
        }
        return;
    }, [
        ref?.current
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};

export { useMutationObserver };
//# sourceMappingURL=use-mutation-observer.js.map
